import { render } from "./Changelog.vue?vue&type=template&id=12bd27eb"
import script from "./Changelog.vue?vue&type=script&lang=js"
export * from "./Changelog.vue?vue&type=script&lang=js"

import exportComponent from "C:\\xampp\\htdocs\\projects\\diafischchen-webpage\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__